import React from "react";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import { MdDriveFolderUpload } from "react-icons/md";
import {
  Avatar,
  Box,
  Button,
  Col,
  Divider,
  FabButton,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Switchbox,
  Typography,
} from "../../../ppui";
import { STATUTORY_KYC_CONST } from "./statutory-kyc-const";

const StatutoryKycCreate = ({
    orginfo,
  orginfoESCI,
  fileInputRef,
  EmployeeESCI,
  onChnageESCI,
  OnBlureESCI,
  ToggleEsci,
  errorsESCI,
  EmployeeEPF,
  onChanageEPF,
  OnBlureEPF,
  ToggleEPF,
  errorsEPF,
  bankdetails,
  onChangeBank,
  // OnBlureBank,
  errorBank,
  handleButtonClick,
  handleFileChange,
  docs,
  alldocs,
  checkDocName,
  DeleteSpecificFile,
  onChangeKYCdoc,
  openFileInNewTab,
  SubmitData
}) => {
 
  return (
    <>
      <Flex justifyContent="space-between" mb={20}>
        <Box>
          <Typography variant="h5" mb={"0"}>
            Employee Under ESI Scheme
          </Typography>
          <Typography variant="body2" mb={"0"}>
            {`Code: ${orginfoESCI?.esi_code}`}
          </Typography>
        </Box>
        <Switchbox disabled={!orginfoESCI?.is_esi} label={`${EmployeeESCI?.esi_availability ? "Disable" : "Enable"} ESI`} color="Primary" name="esi_availability" size="lg" lableFirst checked={EmployeeESCI?.esi_availability} onChange={ToggleEsci} />
      </Flex>

      <Row rowGap>
        <Col sm={12} md={4} lg={4} xl={4}>
          <InputField
            error={!!errorsESCI?.esic_insurance_number}
            helperText={errorsESCI?.esic_insurance_number}
            disabled={!EmployeeESCI?.esi_availability}
            valueSinc={!!EmployeeESCI?.esic_insurance_number}
            value={EmployeeESCI?.esic_insurance_number}
            onChange={(e) => onChnageESCI(e, "esic_insurance_number")}
            onBlur={(e) => OnBlureESCI(e, "esic_insurance_number")}
            {...STATUTORY_KYC_CONST.esic_insurance_number}
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4}>
          <InputField
            error={!!errorsESCI?.esic_registration_date}
            helperText={errorsESCI?.esic_registration_date}
            disabled={!EmployeeESCI?.esi_availability}
            valueSinc={!!EmployeeESCI?.esic_registration_date}
            value={EmployeeESCI?.esic_registration_date}
            onChange={(e) => onChnageESCI(e, "esic_registration_date")}
            onKeyDown={(e)=>e.preventDefault()}
            onBlur={(e) => OnBlureESCI(e, "esic_registration_date")}
            {...STATUTORY_KYC_CONST.esic_registration_date}
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4}>
          <InputField
            error={!!errorsESCI?.esic_card_attachment}
            helperText={EmployeeESCI?.esic_card_attachment?.name}
            disabled={!EmployeeESCI?.esi_availability}
            onChange={(e) => onChnageESCI(e, "esic_card_attachment","file")}
            onBlur={(e) => OnBlureESCI(e, "esic_card_attachment")}
            {...STATUTORY_KYC_CONST.esic_card_attachment}
          />   
        </Col>
      </Row>
      <Divider gap={20} />

      <Flex justifyContent="space-between" mb={20}>
        <Box>
          <Typography variant="h5" mb={"0"}>
            Employee Under EPF Scheme
          </Typography>
          <Typography variant="body2" mb={"0"}>
           {` Code: ${orginfo?.epfOrganizationNumber}`}
          </Typography>
        </Box>
        <Switchbox disabled={!orginfo?.epfOrganizationIsDisabled} label={` ${EmployeeEPF?.epf_availability ? "Disable" : "Enable"} EPF`} color="Primary" size="lg" name="epf_availability" lableFirst checked={EmployeeEPF?.epf_availability} onChange={ToggleEPF} />
      </Flex>

      <Row rowGap>
        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField
            error={!!errorsEPF?.member_payroll}
            helperText={errorsEPF?.member_payroll}
            disabled={!EmployeeEPF?.epf_availability}
            valueSinc={!!EmployeeEPF?.member_payroll}
            defaultValue={EmployeeEPF?.member_payroll}
            onChange={(e) => onChanageEPF(e, "member_payroll")}
            onBlur={(e) => OnBlureEPF(e, "member_payroll")}

            {...STATUTORY_KYC_CONST.member_payroll}
          />
        </Col>
        {
          EmployeeEPF?.member_payroll && <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <InputField
              error={!!errorsEPF?.epf_id_ac_no}
              helperText={errorsEPF?.epf_id_ac_no}
              disabled={!EmployeeEPF?.epf_availability}
              valueSinc={!!EmployeeEPF?.epf_id_ac_no}
              value={EmployeeEPF?.epf_id_ac_no}
              onChange={(e) => onChanageEPF(e, "epf_id_ac_no")}
              onBlur={(e) => OnBlureEPF(e, "epf_id_ac_no")}
              {...STATUTORY_KYC_CONST.epf_id_ac_no}
            />
          </Col>
        }


        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            error={!!errorsEPF?.uan_no}
            helperText={errorsEPF?.uan_no}
            disabled={!EmployeeEPF?.epf_availability}
            valueSinc={!!EmployeeEPF?.uan_no}
            value={EmployeeEPF?.uan_no}
            onChange={(e) => onChanageEPF(e, "uan_no")}
            onBlur={(e) => OnBlureEPF(e, "uan_no")}
            {...STATUTORY_KYC_CONST.uan_no}
          />
        </Col>



        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField
            error={!!errorsEPF?.employee_contribution}
            helperText={errorsEPF?.employee_contribution}
            disabled={!EmployeeEPF?.epf_availability}
            valueSinc={!!EmployeeEPF?.employee_contribution}
            defaultValue={EmployeeEPF?.employee_contribution}
            onChange={(e) => onChanageEPF(e, "employee_contribution")}
            onBlur={(e) => OnBlureEPF(e, "employee_contribution")}
            {...STATUTORY_KYC_CONST.employee_contribution}
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <SelectField
            error={!!errorsEPF?.retired_govt_employee}
            helperText={errorsEPF?.retired_govt_employee}
            disabled={!EmployeeEPF?.epf_availability}
            valueSinc={!!EmployeeEPF?.retired_govt_employee}
            defaultValue={EmployeeEPF?.retired_govt_employee}
            onChange={(e) => onChanageEPF(e, "retired_govt_employee")}
            onBlur={(e) => OnBlureEPF(e, "retired_govt_employee")}
            {...STATUTORY_KYC_CONST.retired_govt_employee}
          />
        </Col>
        {
          EmployeeEPF?.retired_govt_employee && <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
            <InputField
              error={!!errorsEPF?.ppo_no}
              helperText={errorsEPF?.ppo_no}
              disabled={!EmployeeEPF?.epf_availability}
              valueSinc={!!EmployeeEPF?.ppo_no}
              value={EmployeeEPF?.ppo_no}
              onChange={(e) => onChanageEPF(e, "ppo_no")}
              onBlur={(e) => OnBlureEPF(e, "ppo_no")}
              {...STATUTORY_KYC_CONST.ppo_no}
            />
          </Col>
        }

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            error={!!errorsEPF?.epf_registration_date}
            helperText={errorsEPF?.epf_registration_date}
            disabled={!EmployeeEPF?.epf_availability}
            valueSinc={!!EmployeeEPF?.epf_registration_date}
            value={EmployeeEPF?.epf_registration_date}
            onChange={(e) => onChanageEPF(e, "epf_registration_date")}
            onBlur={(e) => OnBlureEPF(e, "epf_registration_date")}
            onKeyDown={(e)=>e.preventDefault()}
            {...STATUTORY_KYC_CONST.epf_registration_date}
          />
        </Col>

        <Col sm={12} md={4} lg={4} xl={4} xxl={3}>
          <InputField
            error={!!errorsEPF?.epf_uan_attachment}
            helperText={EmployeeEPF?.epf_uan_attachment?.name}
            disabled={!EmployeeEPF?.epf_availability}
            valueSinc={!!EmployeeEPF?.epf_uan_attachment}
            onChange={(e) => onChanageEPF(e, "epf_uan_attachment","file")}
            onBlur={(e) => OnBlureEPF(e, "epf_uan_attachment")}
            {...STATUTORY_KYC_CONST.epf_uan_attachment}
          />
        </Col>
      </Row>
      <Divider gap={20} />

      <Typography variant="h5">Bank Details</Typography>

      <Row rowGap>
        <Col sm={12} md={4} lg={4} xxl={3}>
          <InputField
            error={!!errorBank?.bank_name}
            helperText={errorBank?.bank_name}
            valueSinc={!!bankdetails?.bank_name}
            value={bankdetails?.bank_name}
            onChange={(e) => onChangeBank(e, "bank_name")}
            // onBlur={(e) => OnBlureBank(e, "bank_name")}
            {...STATUTORY_KYC_CONST.bank_name}
          />
        </Col>
        <Col sm={12} md={4} lg={4} xxl={3}>
          <InputField
            error={!!errorBank?.branch_name}
            helperText={errorBank?.branch_name}
            valueSinc={!!bankdetails?.branch_name}
            value={bankdetails?.branch_name}
            onChange={(e) => onChangeBank(e, "branch_name")}
            // onBlur={(e) => OnBlureBank(e, "branch_name")}
            {...STATUTORY_KYC_CONST.branch_name}
          />
        </Col>
        <Col sm={12} md={4} lg={4} xxl={3}>
          <InputField
            error={!!errorBank?.account_number}
            helperText={errorBank?.account_number}
            valueSinc={!!bankdetails?.account_number}
            value={bankdetails?.account_number}
            onChange={(e) => onChangeBank(e, "account_number")}
            // onBlur={(e) => OnBlureBank(e, "account_number")}
            {...STATUTORY_KYC_CONST.account_number}
          />
        </Col>

        <Col sm={12} md={4} lg={4} xxl={3}>
          <InputField
            error={!!errorBank?.ifsc_code}
            helperText={errorBank?.ifsc_code}
            valueSinc={!!bankdetails?.ifsc_code}
            value={bankdetails?.ifsc_code}
            onChange={(e) => onChangeBank(e, "ifsc_code")}
            // onBlur={(e) => OnBlureBank(e, "ifsc_code")}
            {...STATUTORY_KYC_CONST.ifsc_code}
          />
        </Col>
        <Col sm={12} md={4} lg={4} xxl={3}>
          <SelectField
            error={!!errorBank?.payment_through}
            helperText={errorBank?.payment_through}
            valueSinc={!!bankdetails?.payment_through}
            defaultValue={bankdetails?.payment_through}
            onChange={(e) => onChangeBank(e, "payment_through")}
            // onBlur={(e) => OnBlureEPF(e, "member_payroll")}
            {...STATUTORY_KYC_CONST.payment_through}
          />
        </Col>
      </Row>

      <Divider gap={20} />

      <Typography variant="h5">KYC Document</Typography>

      <Flex direction="column" gap={30}>
        {
          alldocs?.map((item, index) => (
            <Row rowGap key={index}>

              <Col sm={12} md={4} lg={8}>
                <Flex gap={20}>
                  <Box>
                    <Avatar shape="square" icon={<BsFileEarmarkPdfFill />} />
                  </Box>
                  <Box>
                    <Typography variant="body2" mb={"0"} color={"dark"}>
                      {item?.document_type}
                    </Typography>
                    <Typography variant="h5" mb={"0"}>
                      {item?.document_number}
                    </Typography>
                  </Box>
                </Flex>
              </Col>

              <Col sm={12} md={4} lg={4} xl={3} xxl={2}>
                <Flex gap={10}>
                  <Button
                    onClick={() => DeleteSpecificFile(index)}
                    variant="filled"
                    size="sm"
                    color="danger"
                  >
                    Delete
                  </Button>

                  <Button
                    onClick={() => openFileInNewTab(item?.attachment)}
                    variant="filled"
                    size="sm"
                    color="primary"
                  >
                    View
                  </Button>
                </Flex>
              </Col>
            </Row>
          ))
        }

        <Row rowGap>
          <Col sm={12} md={4} lg={4} xxl={3}>
            <SelectField
              defaultValue={docs?.document_type}
              options={[
                { id: "Aadhaar Card", name: "Aadhaar Card", disabled: checkDocName("Aadhaar Card") },
                { id: "Voter ID", name: "Voter ID", disabled: checkDocName("Voter ID") },
                { id: "PAN Card", name: "PAN Card", disabled: checkDocName("PAN Card") },
                { id: "Driving License", name: "Driving License", disabled: checkDocName("Driving License") },
                { id: "Passport", name: "Passport", disabled: checkDocName("Passport") },
                { id: "Bank Passbook", name: "Bank Passbook", disabled: checkDocName("Bank Passbook") },
                { id: "Cancelled Cheque", name: "Cancelled Cheque", disabled: checkDocName("Cancelled Cheque") },
                { id: "Experience Letter", name: "Experience Letter", disabled: checkDocName("Experience Letter") },
                { id: "Offer Letter", name: "Offer Letter", disabled: checkDocName("Offer Letter") },
                { id: "Education and Qualification Documents", name: "Education and Qualification Documents", disabled: checkDocName("Education and Qualification Documents") },
                { id: "Marksheet/Transcript", name: "Marksheet/Transcript", disabled: checkDocName("Marksheet/Transcript") },
                { id: "Salary Slip", name: "Salary Slip", disabled: checkDocName("Salary Slip") },
              ]}
              onChange={(e) => onChangeKYCdoc(e, "document_type")}
              {...STATUTORY_KYC_CONST.document_type}
            />
          </Col>

          <Col sm={12} md={4} lg={4} xxl={3}>
            <InputField
              value={docs?.document_number ? docs?.document_number : ""}
              valueSinc={!!docs?.document_number}
              onChange={(e) => onChangeKYCdoc(e, "document_number")}
              {...STATUTORY_KYC_CONST.document_number}

            />
          </Col>

          <Col sm={12} md={4} lg={4} xl={3} xxl={2}>
            <FabButton
              icon={<MdDriveFolderUpload />}
              onClick={handleButtonClick}
              shape="extended"
              variant="contained"
            >
              Upload
            </FabButton>


            <input
              ref={fileInputRef}
              type="file"
              accept=".png, .jpg, .jpeg, .doc, .docx, .pdf"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </Col>

        </Row>
      </Flex>
      <Gap height={100} />
      <Flex justifyContent="flex-end" gap={"10"} mt={20}>
        <Button variant="outlined">
          Cancel
        </Button>
        <Button color="primary" onClick={() => { SubmitData("save") }} variant="outlined">
          Save & Exit
        </Button>
        <Button color="primary" onClick={() => { SubmitData("next") }} variant="contained">
          Next
        </Button>
      </Flex>
    </>
  )
}

export default StatutoryKycCreate